import * as React from 'react'
import { translate } from 'react-translate'

class MdTabs extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
  }

  render() {
    let t = this.props.t
    const tabs = this.props.tabs
    const tabStyle = this.props.tabStyle
    const tabWidth = 100/ tabs.length
    return (
      <nav className="general-selector" style={tabStyle}>
        {tabs.map((tab, id) => {
          return <a
            key = {id}
            className={this.props.activeTab === tab.content ? 'active' : null}
            onClick={() => {
              tab.handleClick()
            }}
            style = {{width: `${tabWidth}%`}}
          > {t(tab.content)}
          </a>
        })}
      </nav>
    )
  }
}

export default translate('MdTabs')(MdTabs)



// WEBPACK FOOTER //
// ./react/components/widgets/MdTabs.tsx